"use client"

import * as React from "react"
import { cn } from "lib/utils"

export const Button = React.forwardRef(
  ({ className, variant = "default", size = "md", ...props }, ref) => {
    const base =
      "inline-flex items-center justify-center rounded-md font-medium transition focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50"

    const variants = {
      default:
        "bg-white text-black hover:bg-gray-200 focus:ring-gray-300",
      outline:
        "border border-gray-600 text-gray-200 hover:bg-gray-800 focus:ring-gray-500",
    }

    const sizes = {
      sm: "h-8 px-3 text-sm",
      md: "h-9 px-4 text-sm",
      lg: "h-10 px-6 text-base",
    }

    return (
      <button
        ref={ref}
        className={cn(base, variants[variant], sizes[size], className)}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"